<template>
  <v-container>
    <v-row dense class="mt-9" v-if="loading" align="center" justify="center">
      <v-progress-circular indeterminate />
    </v-row>

    <v-row v-else dense class="mt-9">
      <v-col cols="12">
        <v-card elevation="1" class="header-card">
          <v-card-text>
            <v-row dense class="pa-4">
              <v-col cols="12" md="10">
                <div class="d-flex flex-column">
                  <span class="header">Minhas notificações</span>
                  <span class="regular mt-4">
                    Visualize todas as notificações e comunicados
                  </span>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mt-10">
      <v-col cols="12" md="5">
        <v-row
          class="ma-1 pa-1"
          v-for="(item, index) in notifications"
          :key="index"
        >
          <v-card
            elevation="1"
            class="notification-card d-flex align-center pa-3"
            @click="openNotification(item)"
          >
            <div class="truncate-text">
              <small
                :style="{ color: item.read ? 'grey' : 'green' }"
                class="title"
              >
                {{ item.title }}
              </small>
              <br />
              <small class="date">{{ item.date }}</small>
            </div>
          </v-card>
        </v-row>
      </v-col>

      <v-col cols="12" md="7">
        <v-card v-if="content" class="content-card">
          <v-card-title class="justify-center">
            <span class="text-h6">{{ content.title }}</span>
          </v-card-title>
          <v-card-text>
            <v-row justify="center">
              <small>{{ content.date }}</small>
            </v-row>
            <v-row justify="center" class="mt-2">
              <span>{{ content.description }}</span>
            </v-row>
            <div v-if="content.voting">
              <v-divider class="my-4" />
              <v-row
                justify="center"
                class="d-flex flex-column align-center justify-center"
              >
                <span>Sugestão de alteração</span>
                <span class="font-weight-medium">Você concorda?</span>
              </v-row>
              <v-row justify="center" class="mt-3">
                <v-btn
                  color="primary"
                  class="mb-2 px-6 white--text"
                  @click="vote(true, content.voting)"
                  :disabled="voted"
                  rounded
                  filled
                >
                  Concordo
                </v-btn>
              </v-row>
              <v-row justify="center">
                <v-btn
                  ass="mb-2 px-6 white--text"
                  class="px-6"
                  color="neutral"
                  @click="vote(false, content.voting)"
                  :disabled="voted"
                  rounded
                >
                  Discordo
                </v-btn>
              </v-row>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-pagination
      v-if="!loading && notifications.length > 0"
      class="d-flex align-center mt-6"
      circle
      :length="pagination.size"
      v-model="pagination.currentPage"
    />
  </v-container>
</template>

<script>
import partnerApi from "@/shared/pitchPartnerApi";
export default {
  name: "NotificationsArea",
  created() {
    setTimeout(() => {
      this.loading = false;
      this.$store.getters.user.notificationsCount = null;
    }, 1000);
  },
  mounted() {
    this.getNotifications();
  },
  data() {
    return {
      notifications: [],
      content: null,
      loading: true,
      pagination: {
        currentPage: 1,
        size: 1,
      },
    };
  },
  methods: {
    async openNotification(item) {
      if (!item.read) {
        await partnerApi
          .readNotification(item.id)
          .then(() => {
            item.read = true;
          })
          .catch(() => {
            this.$root.$emit("display-alert", {
              text: "Ocorreu um problema ao ler a notificação.",
              type: 1,
            });
          });
      }
      this.content = item;
    },
    getNotifications(page = 1) {
      this.notifications = [];
      this.loading = true;
      partnerApi
        .getNotifications(page)
        .then((res) => {
          const totalPages = Math.floor(res.data.total / 10);
          this.notifications = res.data.notifications;
          this.pagination.size = totalPages === 0 ? 1 : totalPages;
          this.loading = false;
          console.info(this.pagination);
        })
        .catch(() => {
          this.$root.$emit("display-alert", {
            text: "Ocorreu um problema ao carregar as suas notificações.",
            type: 1,
          });
          this.loading = false;
        });
    },
    vote(option, voteId) {
      this.voted = true;
      partnerApi
        .vote(voteId, option)
        .then(() => {
          this.$root.$emit("display-alert", {
            text: "Opnião registrada com sucesso!",
            type: 0,
          });
          this.getNotifications();
        })
        .catch(() => {
          this.$root.$emit("display-alert", {
            text: "Votação já encerrada!",
            type: 1,
          });
          this.loading = false;
        });
    },
  },
  watch: {
    "pagination.currentPage": {
      handler: function (page) {
        this.getNotifications(page);
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.header-card {
  border-radius: 10px;
}

.header {
  font-family: "Poppins", sans-serif;
  font-size: 22px;
  font-weight: 600;
}

.regular {
  font-family: "Poppins", sans-serif;
  font-size: 14px;
  color: #555;
}

.notification-card {
  width: 100%;
  border-radius: 10px;
  background-color: white;
  overflow: hidden;
  transition: 0.2s;
}

.notification-card:hover {
  background-color: #f8f9fa;
}

.truncate-text {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  text-align: left;
}

.title {
  font-weight: 500;
  font-size: 0.25rem;
  line-height: 1;
  object-fit: contain;
}

.date {
  font-size: 0.75rem;
  color: #888;
}

.content-card {
  border-radius: 10px;
}

.text-h6 {
  font-size: 1rem !important;
  font-weight: 600;
}

.text-left {
  font: 200;
}
</style>
